import { captureException } from 'r/utils';
import { strategiesAtom } from 'r/atoms';
import { useSetAtom } from 'jotai';
import { fetchApiRaw, GET_STRATEGIES } from 'r/utils/fetchApiRaw';
import { useQuery } from '@tanstack/react-query';

export default function useStrategies() {
  const setStrategies = useSetAtom(strategiesAtom);
  const { isPending } = useQuery({
    queryKey: ['strategies'],
    queryFn: async ({ signal }) => {
      try {
        const result = await fetchApiRaw(GET_STRATEGIES, { signal });
        setStrategies(result.data);
        return result;
      } catch (e) {
        captureException(e);
      }
    },
  });
  return { isPending };
}
